import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Title from 'components/UI/Title';
import Tag from 'components/UI/Tag';
import TagCounter from './TagCounter';
import { observer, calculatorState as store } from 'store';
import { tagsManagement } from '../../utils';
import { useTrans } from 'utils/localisation';
import { pushCustomEvent } from 'utils/analytics';

import * as styles from './TagsLayout.module.scss';

function TagsLayout({ counter = true, calculatorID, deviceType }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const t = useTrans(['common', 'calculator']);
  const { updateElementInfo, updateCurrentList } = store;
  const { tags, removeTagHandler } = tagsManagement(calculatorID);

  const titleColor = deviceType === 'desktop' ? 'white' : undefined;

  useEffect(() => {
    if (inView) {
      pushCustomEvent('ndrsn_pricing_modal', {
        action: 'seen_by_user',
        label: calculatorID,
      });
    }
  }, [inView]);

  return (
    <>
      <Title className={styles.tagsTitle} tag="h4" color={titleColor}>
        {t('previewTitle')}
      </Title>
      <div className={styles.wrapper} ref={inViewRef}>
        <div className={styles.columnsWrapper}>
          <section className={styles.column}>
            {tags.others.length ? (
              <div className={styles.elements}>
                {tags.others.map(tag => (
                  <Tag
                    key={`${tag.key}-${tag.counter}`}
                    className={styles.tag}
                    theme={deviceType === 'desktop' ? 'filteredTail' : 'filtered'}
                    onClick={() => removeTagHandler(tag)}
                  >
                    {tag.name}
                  </Tag>
                ))}
              </div>
            ) : (
              <div className={styles.elementsEmpty}>
                {counter ? t('noItemsWithCounter') : t('noChosenItems')}
              </div>
            )}
          </section>
          {counter && (
            <section className={styles.column}>
              <Title className={styles.tagsTitle} tag="h4" color={titleColor}>
                {t('selectedSpecialists')}
              </Title>
              {tags.counters.length ? (
                <ul className={styles.elements}>
                  {tags.counters.map(({ key: sectionName, counter: title, value: count }, i) => (
                    <TagCounter
                      key={`${sectionName}-${title}`}
                      title={title}
                      className={styles.tag}
                      onChangeCount={(counterName, value) => {
                        updateElementInfo(calculatorID, sectionName, counterName, value);
                        updateCurrentList(calculatorID, sectionName, counterName, value);
                      }}
                      value={count}
                      index={i}
                    />
                  ))}
                </ul>
              ) : (
                <div className={styles.elementsEmpty}>{t('noChosenItems')}</div>
              )}
            </section>
          )}
        </div>
      </div>
    </>
  );
}

export default observer(TagsLayout);
